<template>
  <common-dialog
    ref="dialog"
    :title="title"
    width="1200px"
    :in-dialog="inDialog"
  >
    <el-container>
      <type-tree
        ref="typeTree"
        @on-select="onSelect1"
        v-if="loginInfo.UserType == 1"
      ></type-tree>
      <typePlatform-tree
        ref="typePlatformTree"
        @on-select2="onSelect2"
        v-else
      ></typePlatform-tree>
      <!-- <goods-tree ref="goodsTree" :is-edit="false" @on-select2="onTreeSelect"></goods-tree> -->
      <el-main class="my-main">
        <list
          ref="list"
          :show-checkbox="multiple"
          :checkbox-fixed="false"
          :show-status="false"
          is-mall-goods
        >
          <template #column>
            <slot name="column" />
            <template v-if="selectable && !multiple">
              <el-table-column
                label="操作"
                align="center"
                width="60"
                fixed="right"
              >
                <template slot-scope="{ row }">
                  <el-button @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </el-main>
    </el-container>
    <template slot="footer">
      <slot name="footer">
        <el-button
          size="mini"
          type="primary"
          @click="selectMultiple"
          v-if="selectable && multiple"
          >选择</el-button
        >
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
//import goodsTree from "./typePlatformTree";

import typeTree from "@/components/goods/info/typeTree";
import typePlatformTree from "@/components/goods/info/typePlatformTree";

export default {
  components: { commonDialog, list, typeTree, typePlatformTree },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "商品列表",
    },
  },
  data() {
    return {
      data: {
        TypeName: "",
        TypeId: 0,
        TypeIdChain: "",
        TypeNameChain: "",
        TypePlatformIdChain: "",
        TypePlatformName: "",
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      params: {
        SaleState: 1,
      },
    };
  },
  methods: {
    getTree() {
      //this.$refs.goodsTree.getData();
      if (this.loginInfo.UserType == 1) {
        this.$refs.typeTree.getData();
      } else {
        this.$refs.typePlatformTree.getData();
      }
    },
    getData(params) {
      this.params = { ...params };
      this.$refs.list.getData(this.params);
    },
    allData() {
      this.resetSelect();
      this.$refs.list.getData({ ...this.params, TypePlatformIdChain: "" });
      //
    },
    resetSelect() {
      //this.$refs.goodsTree.resetSelect();
      if (this.loginInfo.UserType == 1) {
        this.$refs.typeTree.resetSelect();
      } else {
        this.$refs.typePlatformTree.resetSelect();
      }
      this.data.TypePlatformIdChain = "";
      this.data.TypePlatformName = "";
    },
    onSelect1(data) {
      if (this.data.TypeIdChain != data.IdChain) {
        this.data.TypeId = data.RecordId;
        this.data.TypeName = data.TypeName;
        this.data.TypeIdChain = data.IdChain;
        this.data.TypeNameChain = data.NameChain;
        if (data.RecordId > 0)
          this.$refs.list.getData({
            TypeIdChain: this.data.TypeIdChain,
            SaleState: 1,
          });
        else this.$refs.list.getData({ SaleState: 1 });
      }
    },
    onSelect2(data) {
      //
      if (this.data.TypeIdChain != data.IdChain) {
        this.data.TypePlatformId = data.RecordId;
        this.data.TypePlatformName = data.TypeName;
        this.data.TypePlatformIdChain = data.IdChain;
        this.data.TypePlatformNameChain = data.NameChain;
        if (data.RecordId > 0)
          this.$refs.list.getData({
            TypePlatformIdChain: this.data.TypePlatformIdChain,
            SaleState: 1,
          });
        else this.$refs.list.getData({ SaleState: 1 });
      }
      // if (this.data.IdChain != data.IdChain) {
      //   this.data.IdChain = data.IdChain;
      //   this.data.ClassName = data.ClassName;
      //   this.$refs.list.getData({ ...this.params, TypeIdChain: data.IdChain });
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.my-aside {
  margin-top: 20px;
}
</style>